module.exports = __webpack_public_path__ + "img/funnel.c8c31bae.jpg";